import { isAuthenticated, ROUTE } from "@/utils";
import { FC } from "react";
import { Navigate } from "react-router-dom";
import { ProtectedRouteProps } from "./protected-route.types";

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  return isAuthenticated() ? (
    children
  ) : (
    <Navigate to={ROUTE.AUTH_LOGIN} replace />
  );
};

export { ProtectedRoute };
